@let isActive = (entityId$ | async) === entity().id;
@let hideControls = hideControls$ | async;
@let isFocus = hoverState()?.hover || isActive || isSettingsMenuOpened();

<div
    #blockRoot
    class="block"
    [id]="displayId()"
    [attr.data-raw-id]="displayId()"
    [class.active]="isActive"
    [class.active-more-action]="isSettingsMenuOpened()"
    [webSingleHover]="{ threshold: 100 }"
    (hovered)="hovered($event)"
>
    @if (isFocus) {
        <div
            class="info-label-container"
            [class.row-controls]="itemControls().rowControls"
            [class.basic-controls-position]="itemControls().basicControlsPosition"
            [class.small-top-indent]="itemControls().smallTopIndent"
            [class.small-bottom-indent]="itemControls().smallBottomIndent"
            [class.bottom-inner-controls-position]="itemControls().bottomInnerControlsPosition"
            [class.bottom-outer-controls-position]="itemControls().bottomOuterControlsPosition"
        >
            @if (isShowSpecConditionIcon()) {
                <div class="info-label show-condition" [tooltip]="specConditionTooltip" [tooltipAppendToBody]="true">
                    <img
                        src="./assets/img/websites/lpc-spec-condition-label-icon.svg"
                        [alt]="'spec-condition_tooltip' | translate"
                    />
                    <ng-template #specConditionTooltip>
                        {{ "spec-condition_tooltip" | translate }}
                    </ng-template>
                </div>
            }
            @if (isPinnedTop() || isPinnedBottom()) {
                <div class="info-label" [tooltip]="pinnedBlockTooltip" [tooltipAppendToBody]="true">
                    <img
                        src="./assets/img/websites/lpc-pinned-block-label-icon.svg"
                        [alt]="'control_block_pinned' | translate"
                    />
                    <ng-template #pinnedBlockTooltip>
                        {{ "control_block_pinned" | translate }}
                    </ng-template>
                </div>
            }
            @if (hidden().desktop || hidden().tablet || hidden().mobile) {
                <div class="info-label" [tooltip]="hiddenBlockTooltip" [tooltipAppendToBody]="true">
                    <img [src]="hiddenIconPath()" [alt]="hiddenIconTooltip() | translate" />
                    <ng-template #hiddenBlockTooltip>
                        {{ hiddenIconTooltip() | translate }}
                    </ng-template>
                </div>
            }
        </div>
    }
    <web-default-block-view [entity]="entity()" />

    @if (hideControls) {
        @if (!isPinnedTop() && hoverState()?.topThreshold) {
            <web-add-buttons
                type="top"
                [show]="true"
                [tooltipText]="'control_add_block' | translate"
                (addEvent)="addBlockTop()"
            />
        }
        @if (!isPinnedBottom() && hoverState()?.bottomThreshold) {
            <web-add-buttons
                type="bottom"
                [show]="true"
                [tooltipText]="'control_add_block' | translate"
                (addEvent)="addBlockBottom()"
            />
        }

        @if (isFocus) {
            @let isAdmin = isAdmin$ | async;
            @let isEcommerceMode = isEcommerceMode$ | async;

            <web-default-block-controls
                class="block-controls"
                [class.row-controls]="itemControls().rowControls"
                [class.basic-controls-position]="itemControls().basicControlsPosition"
                [class.small-top-indent]="itemControls().smallTopIndent"
                [class.small-bottom-indent]="itemControls().smallBottomIndent"
                [class.bottom-inner-controls-position]="itemControls().bottomInnerControlsPosition"
                [class.bottom-outer-controls-position]="itemControls().bottomOuterControlsPosition"
                [disableMoveUp]="isFirst() || isPreviousSiblingPinnedToTop() || isPreviousSiblingShared()"
                [disableMoveDown]="isLast() || isNextSiblingPinnedToBottom() || isNextSiblingShared()"
                [disableCopyEvent]="isCartWidgetInside || productBlockRestricted()"
                [disableRemoveEvent]="isCartWidgetInside || productBlockRestricted()"
                [selectActionTooltip]="isEcommerceMode ? '' : ('control_block_settings' | translate)"
                [pinOnTheTop]="isPinnedTop()"
                [pinOnTheBottom]="isPinnedBottom()"
                [copyToPage]="!isAdmin && !isCartWidgetInside && !isEcommerceMode"
                [saveBlockToGallery]="!isAdmin && !isCartWidgetInside && !isEcommerceMode"
                (copyEvent)="copyBlock()"
                (copyToPageEvent)="copyBlockToPage()"
                (saveBlockToGalleryEvent)="saveBlockToGallery()"
                (deleteEvent)="removeBlock()"
                (selectEvent)="selectBlock()"
                (moveUpEvent)="moveUp()"
                (moveDownEvent)="moveDown()"
                (toggleMoreActionState)="setSettingsMenuOpened($event)"
            />
        }
    }
</div>
